import script from "./question.vue?vue&type=script&setup=true&lang=js"
export * from "./question.vue?vue&type=script&setup=true&lang=js"

import "./question.vue?vue&type=style&index=0&id=bf797d42&lang=less"

const __exports__ = script;

export default __exports__